var _path, _path2, _line, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 154,
    viewBox: "0 0 143 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.916 51.9219L1.37615 5.39143",
    stroke: "black",
    strokeWidth: 3.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4249 56.315L141.511 4.27881",
    stroke: "black",
    strokeWidth: 3.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 69.25,
    y1: 49,
    x2: 69.25,
    y2: 7.64949e-8,
    stroke: "black",
    strokeWidth: 3.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71 149.25C33.3066 149.25 2.75 118.693 2.75 81C2.75 43.3066 33.3066 12.75 71 12.75C108.693 12.75 139.25 43.3066 139.25 81C139.25 118.693 108.693 149.25 71 149.25Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 3.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9474 75.2486C78.6515 74.2898 78.2431 73.4316 77.7223 72.674C77.2133 71.9046 76.5978 71.2476 75.8757 70.7031C75.1655 70.1586 74.3487 69.7502 73.4254 69.478C72.5021 69.1939 71.496 69.0518 70.407 69.0518C68.4538 69.0518 66.7138 69.5431 65.1868 70.5256C63.6598 71.508 62.4583 72.9522 61.5824 74.858C60.7183 76.7519 60.2862 79.0601 60.2862 81.7827C60.2862 84.5289 60.7183 86.8549 61.5824 88.7607C62.4465 90.6664 63.648 92.1165 65.1868 93.1108C66.7256 94.0933 68.513 94.5845 70.549 94.5845C72.3956 94.5845 73.9936 94.2294 75.343 93.5192C76.7043 92.8089 77.7519 91.8028 78.4858 90.5007C79.2197 89.1868 79.5866 87.648 79.5866 85.8842L81.0781 86.1151H71.206V80.9659H85.9609V85.3338C85.9609 88.447 85.2981 91.1399 83.9723 93.4126C82.6465 95.6854 80.8236 97.4373 78.5036 98.6683C76.1835 99.8875 73.5201 100.497 70.5135 100.497C67.1636 100.497 64.2221 99.7455 61.6889 98.2422C59.1676 96.727 57.1967 94.5786 55.7763 91.7969C54.3677 89.0033 53.6634 85.6889 53.6634 81.8537C53.6634 78.9181 54.0777 76.2962 54.9062 73.9879C55.7467 71.6797 56.9186 69.7206 58.4219 68.1108C59.9252 66.4891 61.6889 65.258 63.7131 64.4176C65.7372 63.5653 67.9389 63.1392 70.3182 63.1392C72.3305 63.1392 74.2067 63.4351 75.9467 64.027C77.6868 64.607 79.2315 65.4356 80.581 66.5128C81.9422 67.59 83.0608 68.8684 83.9368 70.348C84.8127 71.8277 85.3868 73.4612 85.6591 75.2486H78.9474Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerator);
export default __webpack_public_path__ + "static/media/generator.0295f236c7af6ba1187a1053851da3ca.svg";
export { ForwardRef as ReactComponent };